import React, { useEffect, useState } from "react";
import searchIcon from "../../img/icon-search.png";
import "../../css/common.css";
import dotsIcon from "../../img/icondots.png";
import { Link, useHistory } from "react-router-dom";
import { useFetchData } from "../../hooks/useFetchData";
import { BACKEND_URL, GeneralStatus } from "../../utils/constant";
import { Pagination } from "../../components/Pagination";
import editIcon from "../../img/icon-edit.png";
import trashCanIcon from "../../img/icon-trash.png";
import { useFormatMessage } from "../../hooks/useFormatMessage";
import { useAuth } from "../../context/AuthProvider";
import DeleteConfirmPopup from "../../components/DeleteConfirmPopup";
import { ResetPasswordPopup } from "../../components/ResetPasswordPopup";
import moment from "moment";

export default function CurrencyExchange() {
    const history = useHistory();
    const { setPopup } = useAuth();
    const currentPath = history.location.pathname;
    const [isOptionOpen, setisOptionOpen] = useState(false);
    const { data, setCurrentPage, setQuery, reload } = useFetchData({
        url: BACKEND_URL + "/currencyExchange",
        defaultQuery: "",
    });
    const formatMessage = useFormatMessage();

    const toggleOptions = (id) => {
        const optionEl = document.getElementById(id);
        const activeOptionEl = document.querySelectorAll(".popup-options.open");
        console.log(activeOptionEl);
        if (activeOptionEl.length === 0 || activeOptionEl[0] == optionEl) {
            optionEl.classList.toggle("open");
            setisOptionOpen(optionEl.classList.contains("open"));
        }
    };

    const onSearchChange = (e) => {
        const text = e.target.value;
        setQuery({
            merchant_name: text.trim(),
        });
    };

    const onDeleteClick = (e) => {
        e.preventDefault();
        const id = e.target.parentNode.id
            ? e.target.parentNode.id
            : e.target.parentNode.parentNode.id;
        setPopup(
            <DeleteConfirmPopup id={id} reload={reload} entity="currencyExchange" />
        );
    };

    useEffect(() => {
        const openedEl = document.querySelector(".popup-options.open");

        const handleDocumentClick = (e) => {
            if (e.target != openedEl && !openedEl.contains(e.target)) {
            }
            openedEl.classList.remove("open");
            setisOptionOpen(false);
        };
        if (openedEl) {
            setTimeout(() => {
                document.addEventListener("click", handleDocumentClick);
            }, 100);
        }
        return () => {
            document.removeEventListener("click", handleDocumentClick);
        };
    }, [isOptionOpen]);

    return (
        <div className="page-layout">
            <div className="page-header">
                <h1>{formatMessage("common.currencyExchangeList")}</h1>
                <div className="search-bar">
                    <img src={searchIcon} />
                    <input
                        className="x-input"
                        type="search"
                        onChange={onSearchChange}
                    />
                </div>
                <Link to="/dashboard/currencyExchange/create" className="create-button">
                    {formatMessage("common.createNew")}
                </Link>
            </div>

            <div className="table-container">
                <table className="x-table">
                    <thead>
                        <tr>
                            <th>{formatMessage("common.baseCurrency")}</th>
                            <th>{formatMessage("common.baseAmount")}</th>
                            <th>{formatMessage("common.convertedCurrency")}</th>
                            <th>{formatMessage("common.convertedAmount")}</th>
                            <th>{formatMessage("common.exchangeDate")}</th>
                            <th className="button-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.results.map((item, i) => {
                            const index = (data.page - 1) * data.limit + i + 1;
                            console.log(item)
                            return (
                                <tr key={i} className="hover-effect">
                                    <td>{item.baseCurrency.currency_name}</td>
                                    <td>{item.base_unit}</td>
                                    <td>{item.convertedCurrency.currency_name}</td>
                                    <td>{item.converted_unit}</td>
                                    <td>{moment(item.exchange_date).format('DD/MM/YYYY')}</td>
                                    <td className="button-col">
                                        <div className="flex items-center">
                                           
                                            <img
                                                className="col-button"
                                                src={dotsIcon}
                                                onClick={() =>
                                                    toggleOptions(
                                                        item.cx_rate_id
                                                    )
                                                }
                                            />
                                        </div>
                                        <div
                                            className="popup-options"
                                            id={item.cx_rate_id}
                                        >
                                            <Link
                                                to={`${currentPath}/${item.cx_rate_id}/edit`}
                                            >
                                                <img src={editIcon} />
                                                {formatMessage("common.edit")}
                                            </Link>
                                            <a href="" onClick={onDeleteClick}>
                                                <img src={trashCanIcon} />
                                                {formatMessage("common.remove")}
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="pagination-container">
                <Pagination data={data} setCurrentPage={setCurrentPage} />
            </div>
        </div>
    );
}
